/* ============================================================
   PAMÉ full-page — one 100vh block per gesture, slow eased glide.
   Snaps to each section's MEASURED top (no cumulative drift, so
   no partial "cut-off" of the previous block). Desktop pointer
   only; touch / mobile / reduced-motion use native scrolling.
   The trailing Featured + Footer scroll naturally.
   ============================================================ */
(function () {
  'use strict';

  var DURATION = 1100; // ms — slow, luxurious
  var main = document.getElementById('MainContent');
  if (!main) return;
  if (!document.body.classList.contains('pame-home')) return;

  var mq = window.matchMedia('(min-width: 750px) and (pointer: fine)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  var offsets = []; // measured document-top of each full-height panel

  function collect() {
    var vh = window.innerHeight;
    offsets = Array.prototype.slice.call(main.children)
      .filter(function (el) {
        // include full blocks and the 70vh Featured closing block; skip the tiny opening wrapper
        return el.classList.contains('shopify-section') && el.offsetHeight >= vh * 0.6;
      })
      .map(function (el) {
        return Math.round(el.getBoundingClientRect().top + window.scrollY);
      });
  }

  var animating = false;
  var cooldown = false;

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function animateTo(targetY) {
    var maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    targetY = Math.max(0, Math.min(targetY, maxY));
    var startY = window.scrollY;
    var dist = targetY - startY;
    if (Math.abs(dist) < 2) return;
    animating = true;
    var t0 = null;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / DURATION);
      window.scrollTo(0, startY + dist * easeInOutCubic(p));
      if (p < 1) {
        requestAnimationFrame(step);
      } else {
        animating = false;
        cooldown = true;
        setTimeout(function () { cooldown = false; }, 160);
      }
    }
    requestAnimationFrame(step);
  }

  function nearestIndex() {
    var y = window.scrollY, best = 0, bd = Infinity;
    for (var i = 0; i < offsets.length; i++) {
      var d = Math.abs(offsets[i] - y);
      if (d < bd) { bd = d; best = i; }
    }
    return best;
  }
  function nextIndex() {
    var y = window.scrollY + 4;
    for (var i = 0; i < offsets.length; i++) { if (offsets[i] > y) return i; }
    return offsets.length - 1;
  }
  function prevIndex() {
    var y = window.scrollY - 4;
    for (var i = offsets.length - 1; i >= 0; i--) { if (offsets[i] < y) return i; }
    return 0;
  }

  function onWheel(e) {
    if (!mq.matches || reduce.matches || offsets.length < 2) return;
    if (animating || cooldown) { e.preventDefault(); return; }
    if (Math.abs(e.deltaY) < 4) return;

    var lastTop = offsets[offsets.length - 1];

    if (e.deltaY > 0) {
      // down: hijack until the last block, then let Featured/Footer scroll natively
      if (window.scrollY < lastTop - 4) {
        e.preventDefault();
        animateTo(offsets[nextIndex()]);
      }
    } else {
      // up
      if (window.scrollY > lastTop + 4) {
        e.preventDefault();
        animateTo(lastTop); // return from the tail to the last block
      } else if (window.scrollY > 4) {
        e.preventDefault();
        animateTo(offsets[prevIndex()]);
      }
    }
  }

  function onKey(e) {
    if (!mq.matches || reduce.matches || offsets.length < 2 || animating) return;
    var tag = (e.target.tagName || '').toLowerCase();
    if (tag === 'input' || tag === 'textarea' || e.target.isContentEditable) return;
    var lastTop = offsets[offsets.length - 1];
    if (e.key === 'ArrowDown' || e.key === 'PageDown') {
      if (window.scrollY < lastTop - 4) { e.preventDefault(); animateTo(offsets[nextIndex()]); }
    } else if (e.key === 'ArrowUp' || e.key === 'PageUp') {
      if (window.scrollY > lastTop + 4) { e.preventDefault(); animateTo(lastTop); }
      else if (window.scrollY > 4) { e.preventDefault(); animateTo(offsets[prevIndex()]); }
    }
  }

  function init() {
    collect();
    window.addEventListener('resize', collect);
    window.addEventListener('load', collect);
    window.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('keydown', onKey);
    document.addEventListener('shopify:section:load', collect);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
